<div class="new-pid-component" class="new-pid-component">
  <div *ngIf="working" class="working-background">
    <mat-progress-spinner mode="indeterminate" class="spinner"></mat-progress-spinner>
  </div>
  <!--<div *ngIf="pids.length > 0" class="flexbox">
    <div *ngIf="!parentPID" class="wrapper-select margin-right-md full-width">
      <label for="parentPID" class="select-label">{{translate.instant('NEW_PID.SUB_OF')}}: </label>
      <select #subSelect (change)="subOff(subSelect.value)" class="full-width" id="parentPID"
              [disabled]="pids.length == 0">
        <option [value]="null" selected>&#45;&#45;None&#45;&#45;</option>
        <option *ngFor="let p of possibleParents" [value]="p._id">{{p.name}}</option>
      </select>
    </div>
  </div>-->

  <div class="subPID" *ngIf="parentPID">
    <span>{{translate.instant('NEW_PID.SUB_OF')}} {{parentPID.name}}</span>
    <br /><br />
  </div>

  <form class="full-width-form" *ngIf="types.length > 0" [ngStyle]="{'margin-top' : (isPhone) ? '-75px' : '0'}">

    <h1 *ngIf="!copyOf">{{translate.instant('MAAK OF BEWERK JE DIGITAAL PASPOORT')}}</h1>
    <h1 *ngIf="copyOf">{{translate.instant('MODAL.TITLE.COPY_PID')}}</h1>

    <mat-grid-list cols="6" rowHeight="30px" gutterSize="15px">
      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.NAME')}} *</label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput required [readonly]="newPID.copy" [(ngModel)]="newPID.name" type="text" name="name">
          <mat-hint class="red" align="end" *ngIf="!newPID.name">{{translate.instant('MESSAGE.IS_REQUIRED', {data:
            translate.instant('DATA.NAME')})}}
          </mat-hint>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.FILE_NUMBER')}}</label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newPID.fileNumber" type="text" name="file_number"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.DESCRIPTION')}}</label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newPID.shortDescription" type="text" name="description"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>


      <mat-grid-tile [colspan]="1" class="first">
        <label>{{translate.instant('DATA.STREET_AND_NUMBER')}} *</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" required [(ngModel)]="newPID.address.address" type="text" name="street_and_number"
            class="full-width margin-right-md">

        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" class="first">
        <label>{{translate.instant('DATA.ZIP')}} *</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" class="first">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" required [(ngModel)]="newPID.address.zip" name="zip_code" type="number"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="right" [colspan]="1" class="first">
        <label>{{translate.instant('DATA.CITY')}}*</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" class="first">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" required [(ngModel)]="newPID.address.city" name="city" type="text"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="right" [colspan]="1" class="first">
        <label>{{translate.instant('DATA.COUNTRY')}}*</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" class="first">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" required [(ngModel)]="newPID.address.country" name="country" type="text"
            class="full-width margin-right-md">
          <mat-hint class="red" align="end" *ngIf="!newPID.address.country">
            {{translate.instant('MESSAGE.IS_REQUIRED')}}
          </mat-hint>
        </mat-form-field>
      </mat-grid-tile>


      <mat-grid-tile [colspan]="1" class="first">
        <label>{{translate.instant('DATA.TYPE')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <select *ngIf="!newPID.copy" class="full-width margin-right-md" [(ngModel)]="newPID.type" name="type"
          (change)="updatePreview($event)" id="Type" [disabled]="types.length == 0">
          <option *ngFor="let t of types" [value]="t">{{translate.instant('PID.TYPE.' + t)}}</option>
        </select>
        <input matInput [readonly]="newPID.copy" [(ngModel)]="newPID.type" name="type" placeholder="" id="type"
          class="full-width margin-right-md mat-input-wrapper-align">
      </mat-grid-tile>


      <mat-grid-tile [colspan]="1" class="first">
        <label>{{translate.instant('DATA.CONSTRUCTION_DATE')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" class="second">
        <input matInput [readonly]="newPID.copy" [(ngModel)]="newPID.construction" name="construction" type="date" placeholder="" id="room_1"
          class="full-width margin-right-md mat-input-wrapper-align">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="4">
      </mat-grid-tile>


      <mat-grid-tile [colspan]="1" [rowspan]="2" class="first">
        <label for='file'>{{translate.instant('NEW_PID.PICTURE')}}:</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" [rowspan]="2" class="second">
        <img #imgPreview *ngIf="newPID.img" [src]="newPID.img.url" (error)="fallbackImg($event)"
          class="preview-image" />
        <input type='file' *ngIf="!newPID.copy" name='file' id='file' (change)="fileChangeEvent($event)" />
      </mat-grid-tile>
    </mat-grid-list>

    <hr />

    <h1>{{translate.instant('DATA.OWNER')}}</h1>
    <mat-grid-list cols="6" rowHeight="30px" gutterSize="15px">

      <mat-grid-tile [colspan]="1" class="first">
        <label>{{translate.instant('DATA.OWNER')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">

        <!--<div class="margin-right-md" style="position: relative;">-->
        <!-- * ngIf="!IAmOwner" -->
        <!--<select name="owner"[(ngModel)]="newPID.owner._id" class="full-width margin-right-md"
            (change)="setNewOwner($event)" [disabled]="persons.length == 0"> 
            <option *ngFor="let p of persons" [value]="p._id">{{(p.firstname || p.lastname) ? p.firstname + ' ' +
                  p.lastname : p.company}} ({{p.email}})
            </option>
            <option value="-1" selected>{{translate.instant('DATA.NEW_OWNER')}}</option>
          </select>-->


        <!--  * ngIf="newPID.owner" -->
        <mat-form-field>
          <input [readonly]="newPID.copy" class="full-width margin-right-md" matInput [formControl]="personControl" type="text"
            placeholder="{{translate.instant('DATA.NEW_OWNER')}}" name="owner" [(ngModel)]="newPID.owner"
            [matAutocomplete]="contractorAutocomplete" />

          <mat-autocomplete #contractorAutocomplete="matAutocomplete" (optionSelected)="setNewOwner($event)"
            [displayWith]="formatPerson">
            <mat-option *ngFor="let p of filteredPersons | async" [value]="p">{{formatPerson(p)}}</mat-option>
          </mat-autocomplete>

        </mat-form-field>
      </mat-grid-tile>


      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.FIRSTNAME')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" name="newOwnerFirstName" type="text" #newOwnerFirstname [(ngModel)]="newOwner.firstname"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.LASTNAME')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" name="newOwnerLastName" type="text" [(ngModel)]="newOwner.lastname"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>


      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.COMPANY')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newOwner.company" name="company" type="text" class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.EMAIL')}}*</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" required minlength="4" name="newOwnerEmail" type="email" [(ngModel)]="newOwner.email"
            class="full-width margin-right-md">
          <mat-hint class="red" align="end" *ngIf="!newOwner.email">{{translate.instant('MESSAGE.IS_REQUIRED')}}
          </mat-hint>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.PHONE')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field>
          <input matInput [readonly]="newPID.copy" name="newOwnerPhone" type="text" [(ngModel)]="newOwner.phone"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.STREET_AND_NUMBER')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" class="second">
        <mat-form-field *ngIf="newOwner.address">
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newOwner.address.address" name="address" type="text"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1 class="first">
        <label>{{translate.instant('DATA.ZIP')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1>

        <mat-form-field *ngIf="newOwner.address">
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newOwner.address.zip" name="address.zip" type="number"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="right" [colspan]=1>
        <label>{{translate.instant('DATA.CITY')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1>

        <mat-form-field *ngIf="newOwner.address">
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newOwner.address.city" name="address.city" type="text"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="right" [colspan]=1>
        <label>{{translate.instant('DATA.COUNTRY')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]=1>

        <mat-form-field *ngIf="newOwner.address">
          <input matInput [readonly]="newPID.copy" [(ngModel)]="newOwner.address.country" name="address.country" type="text"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-accordion style="margin-top:15px" class="mat-elevation-z0" *ngIf="changePIDOwnerAllowed()">
      <mat-expansion-panel class="mat-elevation-z0">
        <mat-expansion-panel-header style="flex-grow:10000">
          <mat-panel-description>
            <img height="18px" alt="share" src="../../assets/Nestas_toolbox_delen_narrow.png">
            <span style="margin-left:15px;">{{translate.instant('DATA.TAKEOVER_PID')}}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
  
        <!--{{translate.instant('BUTTON.ACTION.TAKE_PID_OWNERSHIP')}}-->
        <button mat-stroked-button (click)="changePIDOwner(newPID._id)">{{translate.instant('DATA.TAKEOVER_PID_BUTTON')}}</button>
  
        
        <div class="alert-info" style="margin-top:20px">
          <i class="material-icons ic-info">info</i>
          {{translate.instant('DATA.TAKEOVER_PID_INFO')}}
        </div>
        
  
      </mat-expansion-panel>
    </mat-accordion>

    
    <hr />


    <h1>{{translate.instant('RUIMTES / MATERIALEN')}}</h1>
    <mat-grid-list cols="6" gutterSize="15px">

      <mat-grid-tile [colspan]=1>
        <label class="right">{{translate.instant('DATA.NAME')}} ({{rooms.length}})</label>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="5" [rowspan]="roomRowSpan()" class="second">
        <mat-form-field class="example-chip-list">
          <mat-chip-list #chipList aria-label="Room selection">
            <mat-chip *ngFor="let room of rooms" [selectable]="!newPID.copy" [removable]="!newPID.copy"
              (removed)="remove(room)">
              {{room}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input [readonly]="newPID.copy"
              placeholder="Vul de namen van de ruimtes (vb keuken) of materialen die je niet aan één ruimte kunt verbinden (vb. parket) toe."
              #roomInput [formControl]="roomCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($event)">
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let room of filteredRooms | async" [value]="room">
              {{room}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </form>


  <mat-accordion class="mat-elevation-z0" *ngIf="printAllowed() && newPID?._id">
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header style="flex-grow:10000">
        <mat-panel-description>
          <mat-icon>print</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <button mat-stroked-button (click)="printAll(newPID._id)">{{translate.instant('BUTTON.ACTION.PRINTALL_PDF')}}</button>
      <!--<div *ngIf="putUrls && putUrls.pdfUrl"><a href="{{putUrls.pdfUrl}}">PDF url</a></div>
      <div *ngIf="putUrls && putUrls.zipUrl"><a href="{{putUrls.zipUrl}}">ZIP url</a></div>
      <div *ngIf="putToken">{{putToken}}</div>
      <button *ngIf="putUrls && putUrls.zipUrl" mat-stroked-button (click)="completePrint(newPID._id, putToken)">print
        complete</button>-->


        <div style="float:right" *ngIf="newPID.printall && newPID.printall.uploaded">
          <span style="padding-right:5px;">
            <a *ngIf="newPID.printall.pdf" class="step-name" href="{{newPID.printall.pdf.url}}">
              PDF
            </a>
          </span>
          <span>
            <a *ngIf="newPID.printall.zip" class="step-name" href="{{newPID.printall.zip.url}}">
              ZIP
            </a>
          </span>
          ({{newPID.printall.uploaded| date: 'dd/MM/yyyy HH:mm:ss'}})
        </div>

      <div class="alert-info" style="margin-top:20px" *ngIf="printallrequested">
        <i class="material-icons ic-info">info</i>
        {{translate.instant('DATA.PRINTALL_BUSY')}}
      </div>

    </mat-expansion-panel>
  </mat-accordion>





  <!-- File sharing -->
  <div *ngIf="parentPID && parentPIDFiles && parentPIDFiles.length">
    <label class="select-label">{{translate.instant('PID.FILE_SHARING')}}:</label>
    <br />
    <div style="padding-left:15px;">
      <mat-checkbox name="shared_by_all" [(ngModel)]="sharing.all" (change)="selectAll()">
        <span class="margin-left-md">{{translate.instant('PID.SELECT_ALL')}}</span>
      </mat-checkbox>
    </div>
    <br />
    <div *ngFor="let fileSharing of parentPIDFiles" style="padding-left:15px;">
      <mat-checkbox name="shared_by_{{fileSharing.id}}" [(ngModel)]="fileSharing.sharedWith">
        <span class="margin-left-md">{{fileSharing.name}}</span>
      </mat-checkbox>
    </div>
  </div>
</div>